import React from 'react';
import styles from '../styles/ThinkingComponent.module.css';
import NameAlert from "../assets/namealert.png";

export default function ThinkingComponent() {
  return (
    <div className={styles.container} role="status" aria-live="polite">
      <span className={styles.text}>
        Thinking
        <span className={styles.ellipsis}></span>
      </span>
      <img src={NameAlert} className={styles.img}/>
    </div>
  );
}
